import type { Order } from '#domain/Order.ts';

export type OrderOption = {
    id: string;
    label: string;
    selected: boolean;
};

export const getOrderOptions = (relatedOrders: Order[], selectedOrderIds: string[]): OrderOption[] =>
    relatedOrders.map(order => ({
        id: order.id,
        label: order.number,
        selected: selectedOrderIds.includes(order.id),
    }));
